import { render, staticRenderFns } from "./PrevisionV2.vue?vue&type=template&id=bafa902a&"
import script from "./PrevisionV2.vue?vue&type=script&lang=js&"
export * from "./PrevisionV2.vue?vue&type=script&lang=js&"
import style0 from "./PrevisionV2.vue?vue&type=style&index=0&id=bafa902a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports